module.exports = __webpack_public_path__ + "static/Rajdhani-Bold-3d57d256f052ae2212fe1e0a50713adc.ttf";